// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__XAjGp","title":"Info_title__3nvKy","selects":"Info_selects__1-Ttk","requiredAsterisk":"Info_requiredAsterisk__1SJTL"};